<template>
  <div
    class="inline-block"
    :class="{ interactable: interactable }"
    draggable="false"
    @click="onClick"
  >
    <slot name="default"></slot>
    <template v-if="showIcon">
      <slot name="addicon"></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: "DraggableItemPlaceholder",
  props: {
    /**
     * @var Whether to show the plus icon or empty circle
     */
    showIcon: {
      type: Boolean,
      default: true
    },
    /**
     * @var Whether this placeholder can be interacted with. If interactable, this placeholder shows a plus sign.
     * When interacted with, this placeholder emits a @click event.
     */
    interactable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(event) {
      if (!this.interactable) {
        return;
      }
      this.$emit("click", event);
    }
  }
};
</script>
